import { Component, OnInit } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { MySharedService } from '../App/shared.service';
declare function ExportToExcel(item: any[], workSheetName: string, keys: any, Columns?: any): void;

@Component({
    templateUrl: './AppViews/Review/Rating.html'
})

export class RatingComponent implements OnInit {
    userDetail: any;
    public constants: Constants;
    public Rating: any[] = [];
    public MonthList: any[] = [];
    public RatingType: any[] = [];
    public reviewUsers: any[] = [];
    public addRatingData: any = { addRatingUserId: "" };
    public editRatingData: any = { editRatingUserId:"" };
    public isAdd: boolean = true;
    active = true;
    public showLoader = false;
    public existsUserName: boolean = false;
    public isFormSubmitted: boolean = false;
    filter: any = {};

    constructor(private _httpService: HTTPService, private _sharedService: MySharedService) {
        this.constants = new Constants();
        this.filter = { 'MonthYear': "" };
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
    }

    newForm() {
        this.active = false;
        setTimeout(() => this.active = true, 0);
    }

    ngOnInit() {
        
        this.getMonthList();
    }

    ngAfterViewInit() {

        $("#show-filter").click(function () { $(".filter-form").slideToggle() });
    }

    public AddRatingFormLoad() {
        $('#btnAddRatingForm').trigger('click');
    }

    public ResetForm(form: any) {
        form.reset();
        form.resetForm();
        this.isFormSubmitted = false;
    }

    public changeMonth(){
        this.getRating();
        this.getReviewUsers();
        
    }

    public getMonthList() {
        this.showLoader = true;
        this._httpService.ajaxPost('Common/GetMonthList', { }).subscribe(
            data => {
                this.MonthList = data["MonthList"];
                this.filter.MonthYear = this.MonthList[0].MonthId;
                this.getRating();
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    public getReviewUsers() {
        this.showLoader = true;
        this._httpService.ajaxPost('Review/GetReviewUsers', { "ReviewerId": this.userDetail.SiteUserId, "MonthId" : this.filter.MonthYear }).subscribe(
            data => {
                this.reviewUsers = data["ReviewUsers"];
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    public getRating() {
        this.showLoader = true;
        this._httpService.ajaxPost('Review/GetRating', { "ReviewerId": this.userDetail.SiteUserId, "MonthId": this.filter.MonthYear }).subscribe(
            data => {
                this.Rating = data["Rating"];
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    public CancelAddRating() {
        this.existsUserName = false;
        this.addRatingData = { addRatingUserId: "" };
        this.newForm();
        $('#addRating').modal('hide');
        this.isAdd = true;
    }

    public CancelEditRating() {
        this.existsUserName = false;
        this.editRatingData = { editRatingUserId: "" };
        this.newForm();
        $('#editRating').modal('hide');
        this.isAdd = true;
    }

    public AddRating(form: any) {
        this.isFormSubmitted = true;
        if (form.form.valid) {
            this.existsUserName = false;
            this.Rating.forEach(element => {
                if (element.UserId == this.addRatingData.addRatingUserId) {
                    this.existsUserName = true;
                }
            });

            if (!this.existsUserName) {
                let objItem: any = {};
                objItem.ReviewId = 0;
                objItem.UserId =  this.addRatingData.addRatingUserId;
                objItem.ReviewedBy = this.userDetail.SiteUserId;
                objItem.MonthId = this.filter.MonthYear;
                objItem.Rating = this.addRatingData.addRatingValue;
                objItem.Comment = this.addRatingData.addRatingComment;
                this.addEditRating(objItem);
                $('#addRating').modal('hide');
                this.addRatingData = { addRatingUserId: "" };
                this.newForm();
                this.isAdd = true;
            }
        }
    }

    public EditRating(item: any) {
        $('#btnEditRatingForm').trigger('click');
        this.isAdd = false;
        this.EditRatingChange(item.ReviewId);
    }

    public EditRatingChange(itemId) {
        let objItem: any = {};
        objItem = JSON.parse(JSON.stringify(this.Rating.filter((rating) => rating.ReviewId == itemId)[0]));
        this.editRatingData.editRatingId = objItem.ReviewId;
        this.editRatingData.editRatingUserId = objItem.UserId;
        this.editRatingData.editRatingValue = objItem.Rating;
        this.editRatingData.editRatingComment = objItem.Comment;
    }

    public UpdateRating(form: any) {
        this.isFormSubmitted = true;
        if (form.form.valid) {
            this.existsUserName = false;
            this.Rating.forEach(element => {
                if (element.ReviewId != this.editRatingData.editRatingId && element.UserId == this.editRatingData.editRatingUserId) {
                    this.existsUserName = true;
                }
            })

            if (!this.existsUserName) {
                let objItem: any = {};
                objItem.ReviewId = this.editRatingData.editRatingId;
                objItem.UserId = this.editRatingData.editRatingUserId;
                objItem.ReviewedBy = this.userDetail.SiteUserId;
                objItem.MonthId = this.filter.MonthYear;
                objItem.Rating = this.editRatingData.editRatingValue;
                objItem.Comment = this.editRatingData.editRatingComment;
                this.addEditRating(objItem);
                $('#editRating').modal('hide');
                this.editRatingData = { editRatingUserId: "" };
                this.newForm();
                this.isAdd = true;
            }
        }
    }

    addEditRating(objItem) {
        this.showLoader = true;
        this._httpService.ajaxPost('Review/AddUpdateRating', objItem).subscribe(
            data => {
                var msg = data["Status"].Message.split('|');
                if (msg.length > 1) {
                    msg[0] = msg[0].toLowerCase();
                    this._sharedService.ShowMessage(data["Status"].Message);
                }
                else {
                    this._sharedService.ShowMessage(data["Status"].Message);
                }
                this.getRating();
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }
}


/** WEBPACK FOOTER **
 ** ./TypeScripts/Review/Rating.component.ts
 **/